/**
 * AddOpportunityModal Styles
 * 
 * Extracted to keep component file under 300 lines per cursor rules.
 */

import { StyleSheet } from 'react-native';
import { color, text, space, radius, layout } from '../../../shared/tokens/mobile';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: color.background,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: space.md,
    paddingTop: space.lg,
    paddingBottom: space.md,
    borderBottomWidth: 1,
    borderBottomColor: color.border,
  },
  closeButton: {
    width: 44,
    height: 44,
    alignItems: 'center',
    justifyContent: 'center',
  },
  title: {
    fontSize: text.cardTitle.fontSize,
    fontWeight: text.cardTitle.fontWeight,
    color: color.textPrimary,
  },
  scroll: {
    flex: 1,
  },
  scrollContent: {
    padding: space.md,
    paddingBottom: layout.scrollBottomPadding,
  },
  modeSelector: {
    flexDirection: 'row',
    backgroundColor: color.backgroundSecondary,
    borderRadius: radius.md,
    padding: space.xs,
    marginBottom: space.lg,
  },
  modeTab: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: space.sm,
    gap: space.xs,
    borderRadius: radius.sm,
  },
  modeTabActive: {
    backgroundColor: color.surface,
  },
  modeTabText: {
    fontSize: text.body.fontSize,
    fontWeight: text.body.fontWeight,
    color: color.textSecondary,
  },
  modeTabTextActive: {
    color: color.primary,
    fontWeight: text.bodyMedium.fontWeight,
  },
  coordsCard: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: color.primaryLight,
    borderRadius: radius.md,
    padding: space.md,
    marginBottom: space.lg,
    gap: space.sm,
  },
  coordsContent: {
    flex: 1,
  },
  coordsTitle: {
    fontSize: text.body.fontSize,
    fontWeight: text.bodyMedium.fontWeight,
    color: color.primary,
  },
  coordsText: {
    fontSize: text.caption.fontSize,
    color: color.textSecondary,
    marginTop: 2,
  },
  inputGroup: {
    marginBottom: space.md,
  },
  label: {
    fontSize: text.caption.fontSize,
    fontWeight: text.bodyMedium.fontWeight,
    color: color.textSecondary,
    marginBottom: space.xs,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  },
  input: {
    backgroundColor: color.surface,
    borderWidth: 1,
    borderColor: color.border,
    borderRadius: radius.md,
    paddingHorizontal: space.md,
    paddingVertical: space.sm + space.xs,
    fontSize: text.body.fontSize,
    color: color.textPrimary,
  },
  textArea: {
    minHeight: 80,
    textAlignVertical: 'top',
  },
  hint: {
    fontSize: text.caption.fontSize,
    color: color.textMuted,
    marginTop: space.xs,
  },
  row: {
    flexDirection: 'row',
  },
  optionalToggle: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: space.md,
    gap: space.xs,
  },
  optionalToggleText: {
    fontSize: text.body.fontSize,
    color: color.textSecondary,
  },
  optionalFields: {
    marginTop: space.sm,
  },
  errorCard: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: color.errorLight,
    borderRadius: radius.md,
    padding: space.md,
    marginTop: space.md,
    gap: space.sm,
  },
  errorText: {
    flex: 1,
    fontSize: text.body.fontSize,
    color: color.error,
  },
  footer: {
    padding: space.md,
    borderTopWidth: 1,
    borderTopColor: color.border,
    backgroundColor: color.background,
  },
  submitButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: color.primary,
    borderRadius: radius.md,
    paddingVertical: space.md,
    gap: space.sm,
  },
  submitButtonDisabled: {
    backgroundColor: color.disabled,
  },
  submitButtonText: {
    fontSize: text.body.fontSize,
    fontWeight: text.bodyMedium.fontWeight,
    color: color.surface,
  },
});

